import { AxiosResponse } from "axios";
import api from "../../_core/api";
import {
  CreateUserParams,
  ExistingUser,
  GetExistingUserResp,
  GetUsersParams,
  GetUsersResp,
  UserAccountParams
} from "./types";

export const getUsers = async (parameters: GetUsersParams) => {
  const { accountId, ...params } = parameters;
  const { data }: { data: GetUsersResp } = await api({
    method: "GET",
    url: `/customer-users/accounts/${accountId}`,
    params,
  });
  return data;
};

export const getExistingUser = async (email: string) => {
  try {
    const { data }: AxiosResponse<GetExistingUserResp> = await api({
      method: "GET",
      url: `/customer-users/details/${email}`,
    });
    return data;
  } catch (error: any) {
    if (error?.status !== "NOT_FOUND") console.error(error);
    return null;
  }
};

export const createUser = async (parameters: CreateUserParams) => {
  const { accountId, ...params } = parameters;
  const { data }: { data: string } = await api({
    method: "POST",
    url: `/customer-users/accounts/${accountId}`,
    data: params,
  });
  return data;
};

export const assignUser = async ({ accountId, userId }: UserAccountParams) => {
  const { data }: { data: ExistingUser } = await api({
    method: "PUT",
    url: `/customer-users/${userId}/accounts/${accountId}`,
  });
  return data;
};



export const resendWelcomeEmail = async ({ accountId, userId }: UserAccountParams) => {
  return await api({
    method: "POST",
    url: `/customer-users/${userId}/resend-email`,
    params: { "account-id": accountId },
  });
};

export const removeCustomerUserEmailSuppression = async (userId: string) => {
  return await api({
    method: "DELETE",
    url: `/customer-users/${userId}/email-suppression`,
  });
};

export const disableMfa = async (userId: string) => {
  return await api({
    method: "POST",
    url: `/customer-users/${userId}/disable-mfa`,
  });
};
